// Back in stock by email: every [data-bis-form] on the page (the product page's
// panel, the sold-out cards' Notify me). One request to Qortex's waitlist
// endpoint; it emails once when any store's stock returns. The form carries
// the endpoint, shop, product, variant and path as data attributes.
(function () {
  var words = {
    added: "Thanks. We'll email you once when it's back in stock.",
    already: "You're already on the list for this product. We'll email you once when it's back.",
    already_other: "This product is already on the list for another address. We'll email that one when it's back.",
    in_stock: "Good news: it's back in stock. Reload the page to add it to your cart.",
    unavailable: "We can't take requests for this product right now. Email us and we'll help.",
    not_found: "We can't take requests for this product right now. Email us and we'll help.",
    rate_limited: "Too many requests from here just now. Please try again in a few minutes.",
    too_many: "That address is already waiting on five products. We'll email as each comes back.",
    bad_contact: "Please check the email address.",
    generic: "Sorry, that didn't go through. Please try again in a moment."
  };
  function say(form, text, ok) {
    var msg = form.querySelector('[data-bis-msg]'); if (!msg) return;
    msg.hidden = !text; msg.textContent = text || '';
    msg.classList.toggle('is-ok', !!ok); msg.classList.toggle('is-err', !!text && !ok);
  }
  function done(form, text) {
    say(form, text, true);
    form.querySelectorAll('[data-bis-hide]').forEach(function (el) { el.hidden = true; });
  }
  // cards: Notify me opens the form under the price line
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-bis-open]'); if (!open) return;
    var wrap = open.closest('[data-bis-card]'), form = wrap && wrap.parentElement && wrap.parentElement.querySelector('[data-bis-form]'); if (!form) return;
    e.preventDefault(); e.stopPropagation();
    var show = form.hidden; form.hidden = !show; open.setAttribute('aria-expanded', String(show));
    if (show) { var i = form.querySelector('input[type="email"]'); if (i) i.focus(); }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-bis-form]'); if (!form) return;
    e.preventDefault(); e.stopPropagation();
    var input = form.querySelector('input[type="email"]'), btn = form.querySelector('[data-bis-btn]');
    var email = (input && input.value || '').trim();
    if (!email || (input.checkValidity && !input.checkValidity())) { say(form, words.bad_contact); if (input) input.focus(); return; }
    var was = btn ? btn.textContent : ''; if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }
    say(form, '');
    fetch(form.dataset.endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit',
      body: JSON.stringify({ action: 'web_subscribe', shop: form.dataset.shop, product: form.dataset.product, variant: form.dataset.variant, path: form.dataset.path, contact: email, consent: true })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, body: j || {} }; }); })
      .then(function (res) {
        var b = res.body, key = b.status || b.error;
        if (res.ok && (key === 'added' || key === 'already' || key === 'already_other')) { done(form, words[key]); return; }
        if (res.ok && key === 'in_stock') { done(form, words.in_stock); return; }
        if (!res.ok && key === 'unavailable') key = 'generic'; // a 503: the service, not the product
        say(form, (key === 'bad_contact' && b.message) || words[key] || words.generic);
      })
      .catch(function () { say(form, words.generic); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = was; } });
  });
})();
